import io from 'socket.io-client';
import qp from 'query-parse';

import { logError, debugLog as log } from 'shared-services/logger-service';

const WAKE_TIMEOUT = 30000;
let wakeInterval = null;
let lastTime = null;

const SocketService = ({ host, token, deviceId, onConnect, onError, onWake }) => {
    log('[SOCKET LOG] Connecting', 'token', token);

    let lastSocketEvent;

    const socket = io(host, {
        query: qp.toString({
            team_token: token,
            deviceId
        }),
        transports: [ 'websocket' ],
        reconnectionDelay: 5000,
        reconnectionDelayMax: 30000
    });

    return new Promise(resolve => {
        socket.on('connect', async () => {
            log('[SOCKET LOG] Connect');

            const connectResult = await onConnect(lastSocketEvent);

            if (connectResult) {
                lastSocketEvent = new Date();
            }

            resolve(socket);
        });

        socket.on('disconnect', () => {
            log('[SOCKET LOG] Disconnect');
        });

        socket.on('reconnect', () => {
            log('[SOCKET LOG] Reconnect attempt');
        });

        socket.on('reconnect_attempt', () => {
            log('[SOCKET LOG] Reconnect attempt');
        });

        socket.on('reconnect_failed', () => {
            log('[SOCKET LOG] Reconnect failed');
        });

        socket.on('reconnect_error', e => {
            log('[SOCKET LOG] Reconnect error', e);
        });

        socket.on('error', e => {
            log('[SOCKET LOG] Error', e);

            onError(e?.message);
        });

        socket.on('event', event => {
            lastSocketEvent = new Date().getTime();
        });

        socket.on('socket_error', error => {
            log('[SOCKET LOG] Socket error');

            logError('socket', new Error(error.message));

            onError(error.message);
        });

        lastTime = new Date().getTime();

        if (wakeInterval) {
            clearInterval(wakeInterval);
        }

        wakeInterval = setInterval(() => {
            const currentTime = new Date().getTime();

            if (currentTime > (lastTime + WAKE_TIMEOUT + 2000)) {
                onWake && onWake(lastSocketEvent);
                lastSocketEvent = new Date();
            }

            lastTime = currentTime;
        }, WAKE_TIMEOUT);
    });
}

export default SocketService;
